import { SectionLabel } from "@/components/SectionLabel";
import { ShieldCheck } from "lucide-react";

export const TrustBox = () => {
  return (
    <div className="sidebar-block fade-in" data-testid="trust-box">
      <SectionLabel icon="🛡️" title="How We Work" />
      
      <div className="bg-[#F0FBF5] border-l-[3px] border-scoop-sage rounded-r p-4">
        <p className="text-sm text-[#1A5C3A] leading-relaxed">
          Every story on <strong className="font-bold">The Scoop</strong> goes through a{" "}
          <strong className="font-bold">three-layer safety check</strong> — an age-appropriate rewrite,
          a keyword backstop, and a separate kid-safety classifier that publishes a story only when
          it&rsquo;s explicitly judged safe. Every decision is logged so we can show our work.
        </p>
        <a
          href="/guidelines"
          className="inline-block mt-2.5 text-[0.7rem] font-bold tracking-wider uppercase text-scoop-sage hover:underline"
          data-testid="guidelines-link"
        >
          View our guidelines →
        </a>
      </div>
    </div>
  );
};

export default TrustBox;
